import React from 'react';
import EspecialCardMenu from "../../../shared/components/especial_card_menu/especial_card_menu";

const VideoInformation = ({ url }) => {
  
  return (
    <div className="mb-3 rounded-bottom">
      <EspecialCardMenu title="Video" containerClasses="bg-transparent">
        <iframe width="100%" height="350" src={url} />
      </EspecialCardMenu>
    </div>

  );
};

export default VideoInformation;